import React from 'react';

export default class BodyTheme extends React.Component {

  static propTypes = {
    themeClass: React.PropTypes.string.isRequired,
    children: React.PropTypes.object
  };

  componentDidMount() {
    document.body.classList.add(this.props.themeClass);
  }

  componentWillUnmount() {
    document.body.classList.remove(this.props.themeClass);
  }

  render () {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/views/bodyTheme.jsx